// ═══════════════════════════════════════════════════════════════════
// RAIL ABRA — bouton fin bleu à gauche de l'accueil (desktop uniquement)
// ═══════════════════════════════════════════════════════════════════
// Porte d'entrée abracadabati.com : la page AbracadaBati s'affiche en
// grand, et Abracada reste accessible via ce rail replié. Un clic ouvre
// le panneau bleu (raccourcis cockpit + Abra), un clic dehors le referme.
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import {
  ChevronRight, X, Home, Users, Store, Network, Briefcase,
  LayoutDashboard, Sparkles, HandHeart,
} from 'lucide-react';

const BLEU_COCKPIT = 'linear-gradient(180deg, #1E3A5F 0%, #152a45 100%)';

const LIENS = [
  { label: 'Mon espace', icon: Home, path: '/cockpit-particulier' },
  { label: 'Artisans', icon: Users, path: '/artisans' },
  { label: 'Acheter à un pro', icon: Store, path: '/produits' },
  { label: 'Entre particuliers', icon: HandHeart, path: '/entre-particuliers' },
  { label: 'Réseau', icon: Network, path: '/reseau' },
  { label: 'Emploi', icon: Briefcase, path: '/emploi' },
  { label: 'Espace Pro', icon: LayoutDashboard, path: '/pro' },
];

export default function AbraRail() {
  const [ouvert, setOuvert] = useState(false);
  const navigate = useNavigate();

  const aller = (path) => {
    setOuvert(false);
    navigate(path);
  };

  return (
    <div className="hidden md:block">
      {/* ── Rail replié : bouton fin collé au bord gauche ── */}
      <AnimatePresence>
        {!ouvert && (
          <motion.button
            initial={{ x: -56, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -56, opacity: 0 }}
            transition={{ type: 'spring', damping: 26, stiffness: 300 }}
            onClick={() => setOuvert(true)}
            aria-label="Ouvrir Abracada"
            className="fixed left-0 top-1/2 -translate-y-1/2 z-[1100] flex flex-col items-center gap-3 py-4 px-1.5 rounded-r-2xl shadow-lg hover:shadow-xl transition-shadow"
            style={{ background: BLEU_COCKPIT }}
          >
            <img
              src="/icons/abracada-logo.svg"
              alt="Abracada"
              className="w-7 h-7 rounded-lg"
            />
            <span
              className="text-white/90 text-[11px] font-semibold tracking-widest select-none"
              style={{ writingMode: 'vertical-rl' }}
            >
              ABRACADA
            </span>
            <ChevronRight className="w-4 h-4 text-orange-400" />
          </motion.button>
        )}
      </AnimatePresence>

      {/* ── Panneau ouvert : menu bleu 300px ── */}
      <AnimatePresence>
        {ouvert && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="fixed inset-0 bg-black/40 z-[1190]"
              onClick={() => setOuvert(false)}
            />
            <motion.aside
              initial={{ x: -300 }}
              animate={{ x: 0 }}
              exit={{ x: -300 }}
              transition={{ type: 'spring', damping: 30, stiffness: 300 }}
              className="fixed left-0 top-0 bottom-0 w-[300px] z-[1200] flex flex-col"
              style={{ background: BLEU_COCKPIT }}
            >
              {/* En-tête */}
              <div className="flex items-center justify-between px-4 pt-5 pb-4 border-b border-white/10">
                <div className="flex items-center gap-2.5">
                  <img
                    src="/icons/abracada-logo.svg"
                    alt="Abracada"
                    className="w-9 h-9 rounded-xl"
                  />
                  <div>
                    <p className="text-white font-bold leading-tight">Abracada</p>
                    <p className="text-white/60 text-xs leading-tight">
                      Ton écosystème
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => setOuvert(false)}
                  aria-label="Fermer"
                  className="p-1.5 rounded-lg text-white/70 hover:text-white hover:bg-white/10 transition-colors"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>

              {/* CTA Abra */}
              <button
                onClick={() => aller('/cockpit-particulier')}
                className="mx-4 mt-4 flex items-center gap-2.5 px-4 py-3 rounded-xl text-white font-semibold shadow-md hover:brightness-110 transition"
                style={{
                  background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
                }}
              >
                <Sparkles className="w-5 h-5" />
                Demander à Abra
              </button>

              {/* Raccourcis */}
              <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-1">
                {LIENS.map(({ label, icon: Icon, path }) => (
                  <button
                    key={path}
                    onClick={() => aller(path)}
                    className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-white/85 hover:text-white hover:bg-white/10 transition-colors text-sm font-medium"
                  >
                    <Icon className="w-[18px] h-[18px] text-orange-300" />
                    {label}
                  </button>
                ))}
              </nav>

              <p className="px-4 pb-4 text-white/40 text-[11px]">
                AbracadaBati — l'univers Bâtiment d'AbracadaWorld
              </p>
            </motion.aside>
          </>
        )}
      </AnimatePresence>
    </div>
  );
}
